import { Col, Row } from "react-bootstrap";
import ModalContainer, {
  ModelContainerProps,
} from "../../../../shared/oversight-core/ui-elements/modal-container/modal-container";

const SaveDataModal = (props: ModelContainerProps) => {
  const { show, onClose, onConfirm } = props;

  return (
    <ModalContainer
      show={show}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={onConfirm}
      confirmButtonText="Login & Save"
      title={"Save Data"}
    >
      <Row>
        <Col className="text-color-2">
          Save and login to Chloride Exide? To save your information you must be
          logged in to the system.
        </Col>
      </Row>
    </ModalContainer>
  );
};

export default SaveDataModal;
